module.exports = __webpack_public_path__ + "img/inactive-account.9c90cda0.svg";